import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useSERVICE_ORDERS_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'SERVICE_ORDERS_COUNTER',
    name: t('widgets.serviceOrdersCounter.name'),
    description: t('widgets.serviceOrdersCounter.description'),
    color: 'darkGreen',
    icon: 'RiTimerLine',
    categories: [t('widgets.serviceOrdersCounter.category')],
    previewWidth: '100%',

    initialState: {
      name: t('widgets.serviceOrdersCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
